import { gql } from '@apollo/client';

export const QuestionFragment = gql`
  fragment Question on Question {
    id
    questionId
    questionCode
    displayText
    displayOrder
    displaySubtext
    placeholder
    inputType
    answerType
    questionChoices {
      id
      choiceCode
      displayText
      displayOrder
      displaySubtext
      selected
    }
    answerValue
    parentQuestionChoice {
      id
      parentQuestionId
    }
  }
`;
